export const COMMENT_LIST_FETCH_START = 'COMMENT_LIST_FETCH_START';
export const COMMENT_LIST_FETCH_SUCCESS = 'COMMENT_LIST_FETCH_SUCCESS';
export const COMMENT_LIST_FETCH_FAILURE = 'COMMENT_LIST_FETCH_FAILURE';
export const COMMENT_LIST_LOAD_START = 'COMMENT_LIST_LOAD_START';
export const COMMENT_LIST_LOAD_SUCCESS = 'COMMENT_LIST_LOAD_SUCCESS';
export const COMMENT_LIST_LOAD_FAILURE = 'COMMENT_LIST_LOAD_FAILURE';
export const SET_COMMENT_UNSHIFT = 'SET_COMMENT_UNSHIFT';
export const SET_COMMENT_NESTED = 'SET_COMMENT_NESTED';
export const UPDATE_COMMENT_DUPLICATE = 'UPDATE_COMMENT_DUPLICATE';
export const COMMENT_DELETE = 'COMMENT_DELETE';
